import { ArrowRightOutlined } from '@ant-design/icons';
import type { RangeValue } from 'rc-picker/es/interface';
import React from 'react';

import type { Dayjs } from 'app/utils/dayjs';

import { RangePicker as RangePickerAnt } from '../dayjsPickers';

import './RangePicker.scss';

type Props = {
  value: RangeValue<Dayjs | null>;
  onChange: (value: RangeValue<Dayjs>) => void;
  editing: boolean;
  label: string;
  id: string;
};

export const RangePicker = ({ value, onChange, editing, id, label }: Props) => {
  const compToRender = editing ? (
    <RangePickerAnt
      value={value}
      onCalendarChange={onChange}
      format="DD-MM-YYYY"
      getPopupContainer={(trigger) => trigger.parentElement || trigger}
    />
  ) : (
    <div>
      {value && value[0]?.format('DD-MM-YYYY')}
      <ArrowRightOutlined />
      {value && value[1]?.format('DD-MM-YYYY')}
    </div>
  );

  return (
    <div className="input-datepicker">
      <label htmlFor={id}>{label}</label>
      {compToRender}
    </div>
  );
};
